export default "__VITE_ASSET__BHhaQ$YN__"